import { combineReducers } from 'redux'
import { REDUCER_NAME } from './const'
import { reducer as detailReducer, REDUCER_NAME as DETAIL_REDUCER } from './detail'
import { reducer as searchReducer, REDUCER_NAME as SEARCH_REDUCER } from './search'

const reducer = combineReducers({
    [DETAIL_REDUCER]: detailReducer,
    [SEARCH_REDUCER]: searchReducer,
})

export {
    reducer,
    REDUCER_NAME,
}



// WEBPACK FOOTER //
// ./src/modules/appointment/state/index.js